export default __webpack_public_path__ + "static/img/Letinte36.26b86bb.jpg";